export default "__VITE_ASSET__CpMWCvSD__"